type InfoIconProps = {
    width?: number
    height?: number
    stroke?: string
    strokeWidth?: number
}

export const InfoIcon = ({
    width = 12,
    height = 12,
    stroke = '#6A6E6E',
    strokeWidth = 1.2
}: InfoIconProps) => (
    <svg className="mt-[2px]" width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.65067 10.6978C8.43925 10.6978 10.6998 8.4373 10.6998 5.64872C10.6998 2.86017 8.43925 0.599609 5.65067 0.599609C2.86213 0.599609 0.601562 2.86017 0.601562 5.64872C0.601562 8.4373 2.86213 10.6978 5.65067 10.6978Z"
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.48438 7.97461H6.81473"
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.65179 7.97461V5.25586H4.875"
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.65513 3.51144C5.54788 3.51144 5.46094 3.42449 5.46094 3.31724C5.46094 3.20999 5.54788 3.12305 5.65513 3.12305"
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.65625 3.51144C5.7635 3.51144 5.85045 3.42449 5.85045 3.31724C5.85045 3.20999 5.7635 3.12305 5.65625 3.12305"
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
